import { Navigate } from 'react-router';

import type { FunctionComponent } from 'react';

export const RedirectToJobArchitectureV2: FunctionComponent = () => {
    return <Navigate to="/job-architecture-v2" />;
};
